import { render, staticRenderFns } from "./GerarResultado.vue?vue&type=template&id=16c17969"
import script from "./GerarResultado.vue?vue&type=script&lang=js"
export * from "./GerarResultado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports